import { gql } from "@apollo/client";
import SearchableQuerySelector from "components/shared/SearchableQuerySelector";

const FETCH_CUSTOMERS = gql`
  query FETCH_CUSTOMERS {
    customers(prefetchProductionPlans: true) {
      id
      name
      system
      odooPartnerId
      priceList {
        id
      }
    }
  }
`;

const sortCustomers = (customers = []) => {
  const isChinese = (str) => /[\u3400-\u9FBF]/.test(str || "");

  return [...customers].sort((a, b) => {
    const aIsChinese = isChinese(a.name);
    const bIsChinese = isChinese(b.name);
    if (aIsChinese && !bIsChinese) return -1;
    if (!aIsChinese && bIsChinese) return 1;
    return a.name.localeCompare(b.name);
  });
};

const CustomersSelector = ({ value, onChange, disabled, className = "" }) => {
  const valueView = value ? (
    <div>
      [{value.system}] {value.name}
    </div>
  ) : null;

  return (
    <SearchableQuerySelector
      className={className}
      query={FETCH_CUSTOMERS}
      queryVariables={{}}
      buildQueryVariables={() => ({})}
      resolveOptions={(data, { searchText }) =>
        sortCustomers(data?.customers || []).filter((customer) => {
          if (!searchText) return true;
          const keyword = searchText.toLowerCase();
          return (
            customer.name?.toLowerCase().includes(keyword) ||
            customer.system?.toLowerCase().includes(keyword)
          );
        })
      }
      optionView={(customer) => (
        <div>
          [{customer.system}] {customer.name}
        </div>
      )}
      valueView={valueView}
      onSelect={onChange}
      disabled={disabled}
      placeholder="Select a customer"
      loadingText="Loading customers..."
      emptyText="No customer found"
      fetchPolicy="network-only"
      autoFocus
    />
  );
};

export default CustomersSelector;
